import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-parent" }
const _hoisted_2 = { class: "search-place" }
const _hoisted_3 = { class: "command-panel" }
const _hoisted_4 = { class: "labels-place" }
const _hoisted_5 = { class: "total-label" }
const _hoisted_6 = {
  key: 0,
  class: "selected-label"
}
const _hoisted_7 = { class: "quick-filters-place" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Download .JSON ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Start new assessment ")
const _hoisted_10 = {
  key: 0,
  class: "command-panel filters-place"
}
const _hoisted_11 = { class: "labels-place" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "total-label" }, "Selected filters: ", -1)
const _hoisted_13 = {
  key: 0,
  class: "filter-name"
}
const _hoisted_14 = { class: "quick-filters-place" }
const _hoisted_15 = { class: "table-parent" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("View subject details ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Edit subject ")
const _hoisted_19 = { class: "paging-place" }
const _hoisted_20 = { class: "paging-label" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")
  const _component_FilterIcon = _resolveComponent("FilterIcon")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_DrawerContent = _resolveComponent("DrawerContent")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SearchInput, {
        modelValue: _ctx.state.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.search = $event)),
        "debounce-time": 500,
        onDebounceInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchChanged()))
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, "Total: " + _toDisplayString(_ctx.state.paging.total), 1),
        (_ctx.list.selected.length)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.list.selected.length) + " selected ", 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.hasRole(_ctx.UserRole.Analyst))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "edit-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadJSON())),
              disabled: !_ctx.list.selected.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DownloadIcon),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (false && _ctx.forbidForRole(_ctx.UserRole.Analyst))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "edit-button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startNewAssesment())),
              disabled: !_ctx.list.selected.length
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PlayCircleIcon),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openFilter()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FilterIcon)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.state.filterPreset)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.state.filterPreset)
              ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.state.filterPreset.name), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("a", {
              class: "reset-filters-link",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetFilters()))
            }, "Reset filters")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_15, [
      _withDirectives(_createVNode(_component_el_table, {
        class: "list-table",
        ref: "multipleTable",
        data: _ctx.list.data,
        style: {"width":"100%"},
        "header-row-class-name": "header-row",
        stripe: true,
        "select-on-indeterminate": false,
        "empty-text": 
          _ctx.state.filterPreset
            ? 'There is no subject that matches the entered parameters. Please reset or change filter criteria'
            : 'Nothing is found. Please change your search parameters'
        ,
        onSelectionChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectionChange($event))),
        onSelectAll: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectAll($event)))
      }, {
        default: _withCtx(() => [
          (_ctx.hasRole(_ctx.UserRole.Analyst))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "55",
                fixed: ""
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Name",
            "min-width": "150",
            fixed: ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Subject ID',
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.subject_id),
                onChangeSorting: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.subject_id, $event)))
              }, null, 8, ["sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.viewSubject(scope.row)), ["prevent"])
              }, _toDisplayString(scope.row[_ctx.fieldNames.subject_id]), 9, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.hasRole(_ctx.UserRole.SystemAdmin, _ctx.UserRole.Analyst))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                property: "site_name",
                label: "Site",
                "min-width": "240"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_TableHeaderComponent, {
                    header: 'Site',
                    filterable: true,
                    filterData: _ctx.state.filtersData.sites,
                    sortable: true,
                    sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.site_id),
                    onChangeSorting: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.site_id, $event)))
                  }, null, 8, ["filterData", "sortingValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Sex",
            width: "120"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Sex',
                filterable: true,
                filterData: _ctx.state.filtersData.sex_type,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.sex_type),
                onChangeSorting: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.sex_type, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatSex(scope.row[_ctx.fieldNames.sex_type])), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            property: _ctx.fieldNames.age,
            label: "Age",
            "min-width": "85"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Age',
                filterable: true,
                rangeData: _ctx.state.filtersData.age,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.age),
                onChangeSorting: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.age, $event)))
              }, null, 8, ["rangeData", "sortingValue"])
            ]),
            _: 1
          }, 8, ["property"]),
          _createVNode(_component_el_table_column, {
            property: _ctx.fieldNames.last_assessment_date,
            label: "Last assessment date",
            "min-width": "180"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Last assessment date',
                sortable: true,
                sortingValue: 
                _ctx.getSortingValueForField(_ctx.fieldNames.assessment_time)
              ,
                onChangeSorting: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.assessment_time, $event)))
              }, null, 8, ["sortingValue"])
            ]),
            default: _withCtx((scope) => [
              (scope.row.internal_subject_id)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.goAssessment(scope.row)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.assessment_timestamp)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["property"]),
          _createVNode(_component_el_table_column, {
            label: "Predicted MMSE",
            "min-width": "150"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Predicted MMSE',
                filterable: true,
                rangeData: _ctx.state.filtersData.score_mmse,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.score_mmse),
                onChangeSorting: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.score_mmse, $event)))
              }, null, 8, ["rangeData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.score_mmse), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Predicted ADAScog",
            "min-width": "160"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Predicted ADAScog',
                filterable: true,
                rangeData: _ctx.state.filtersData.score_adascog,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.score_adascog),
                onChangeSorting: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.score_adascog, $event)))
              }, null, 8, ["rangeData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.score_adascog), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            "class-name": "actions-cell",
            label: "Actions",
            fixed: "right",
            width: "83"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, {
                type: "primary",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        onClick: ($event: any) => (_ctx.viewSubject(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      (_ctx.forbidForRole(_ctx.UserRole.Analyst))
                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: 0,
                            onClick: ($event: any) => (_ctx.editSubject(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "empty-text"]), [
        [_directive_loading, _ctx.state.isLoading]
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
          _hoisted_22,
          _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
          _hoisted_23
        ]),
        (_ctx.state.paging.total > _ctx.state.paging.pageSize)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              class: "table-paging",
              layout: "prev, pager, next",
              "current-page": _ctx.state.paging.page,
              "page-size": _ctx.state.paging.pageSize,
              "pager-count": 5,
              total: _ctx.state.paging.total,
              onCurrentChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.pageChange($event)))
            }, null, 8, ["current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DrawerContent, {
      show: _ctx.state.drawer,
      onApplyFilter: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setFilterFromDrawer($event))),
      onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.cancelFromDrawer())),
      onDrawerClosed: _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.drawer = false))
    }, null, 8, ["show"])
  ]))
}